import React from 'react'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'
import m from 'moment'
import _ from 'lodash'

import { allMomentsQuery } from '../moment/withMomentDays'
import { updateMomentMutation } from '../updateMoment/UpdateMoment'

export const createMomentMutation = gql`
  mutation CreateMomentMutation(
    $message: String!
    $momentAt: DateTime!
    $userId: ID!
  ) {
    createMoment(message: $message, momentAt: $momentAt, userId: $userId) {
      id
      momentAt
      message
    }
  }
`

function updateCacheOnCreated(userId) {
  return (cache, { data: { createMoment } }) => {
    const { allMoments } = cache.readQuery({
      query: allMomentsQuery,
      variables: { userId },
    })
    try {
      cache.writeQuery({
        query: allMomentsQuery,
        data: { allMoments: [createMoment, ...allMoments] },
        variables: { userId },
      })
    } catch (e) {}
  }
}

const handleSave = createMoment => updateMoment => userId => momentId => values => {
  const save = momentId ? updateMoment : createMoment
  return save({
    variables: {
      ...values,
      id: momentId,
      userId,
    },
  })
}

const CreateMoment = ({ userId, children }) => (
  <Mutation
    mutation={createMomentMutation}
    update={updateCacheOnCreated(userId)}
  >
    {(createMoment, createdMomentResponse) => (
      <Mutation mutation={updateMomentMutation}>
        {updateMoment =>
          children({
            moment: { message: '', momentAt: m() },
            onSaveMoment: handleSave(createMoment)(updateMoment)(userId)(
              _.get(createdMomentResponse, 'data.createMoment.id'),
            ),
          })
        }
      </Mutation>
    )}
  </Mutation>
)

export default CreateMoment



// WEBPACK FOOTER //
// ./src/components/templates/createMoment/CreateMoment.js